import TwoFactorAuthAppStates from '../constants/TwoFactorAuthAppStates';
import TwoFactorAuthLevels from '../constants/TwoFactorAuthLevels';
import TwoFactorAuthActionTypes from '../actions/TwoFactorAuthActionTypes';
const initialState = {
  appState: TwoFactorAuthAppStates.DEFAULT,
  backupCodesEnabled: true,
  credentials: {},
  isGenericTwoFactorErrorAlertVisible: false,
  isInvalidCodeAlertVisible: false,
  isInvalidTokenAlertVisible: false,
  isLoginWithHSPrompt: false,
  isNewCodeSentAlertVisible: false,
  isCodeCallAlertVisible: false,
  isRequestingCode: false,
  isSmsRateLimitAlertVisible: false,
  isTokenExpiredAlertVisible: false,
  isUserDeactivatedAlertVisible: false,
  isBlockedLoginMethodAlertVisible: false,
  isRestrictedIpAddressAlertVisible: false,
  isPasskeyUnsupportedAlertVisible: false,
  vettingUrl: '',
  isVerifying: false,
  primary: null,
  rememberThisDevice: true,
  secondary: null,
  token: null,
  totp: '',
  twoFactorLevel: TwoFactorAuthLevels.PRIMARY,
  usePasskey: false,
  passkeyAaguids: []
};
export default function twoFactorAuth(state = initialState, action) {
  var _primaryMethod$second, _primaryMethod$second2, _secondaryMethod$seco, _secondaryMethod$seco2;
  const {
    allowedMethods
  } = action.payload || {};
  const primaryMethod = allowedMethods === null || allowedMethods === void 0 ? void 0 : allowedMethods.find(method => method.first === 'PRIMARY');
  const secondaryMethod = allowedMethods === null || allowedMethods === void 0 ? void 0 : allowedMethods.find(method => method.first === 'SECONDARY');
  switch (action.type) {
    case TwoFactorAuthActionTypes.RESET_STATE:
      return initialState;
    case TwoFactorAuthActionTypes.START_VERIFYING:
      return Object.assign({}, state, {
        isVerifying: true,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });
    case TwoFactorAuthActionTypes.FINISH_VERIFYING:
      return Object.assign({}, state, {
        isVerifying: false
      });
    case TwoFactorAuthActionTypes.START_REQUESTING_CODE_CALL:
    case TwoFactorAuthActionTypes.START_REQUESTING_CODE:
      return Object.assign({}, state, {
        isRequestingCode: true,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });
    case TwoFactorAuthActionTypes.FINISH_REQUESTING_CODE_CALL:
    case TwoFactorAuthActionTypes.FINISH_REQUESTING_CODE:
      return Object.assign({}, state, {
        isRequestingCode: false
      });
    case TwoFactorAuthActionTypes.UPDATE_TOTP:
      return Object.assign({}, state, {
        totp: action.payload.totp,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SET_TWO_FACTOR_METHOD:
      return Object.assign({}, state, {
        token: action.payload.token,
        twoFactorLevel: primaryMethod ? TwoFactorAuthLevels.PRIMARY : TwoFactorAuthLevels.SECONDARY,
        primary: {
          method: primaryMethod === null || primaryMethod === void 0 || (_primaryMethod$second = primaryMethod.second) === null || _primaryMethod$second === void 0 ? void 0 : _primaryMethod$second.method,
          obfuscatedInfo: primaryMethod === null || primaryMethod === void 0 || (_primaryMethod$second2 = primaryMethod.second) === null || _primaryMethod$second2 === void 0 ? void 0 : _primaryMethod$second2.obfuscatedInfo
        },
        secondary: {
          method: secondaryMethod === null || secondaryMethod === void 0 || (_secondaryMethod$seco = secondaryMethod.second) === null || _secondaryMethod$seco === void 0 ? void 0 : _secondaryMethod$seco.method,
          obfuscatedInfo: secondaryMethod === null || secondaryMethod === void 0 || (_secondaryMethod$seco2 = secondaryMethod.second) === null || _secondaryMethod$seco2 === void 0 ? void 0 : _secondaryMethod$seco2.obfuscatedInfo
        },
        backupCodesEnabled: action.payload.backupCodesEnabled,
        totp: '',
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false,
        isNewCodeSentAlertVisible: false,
        isCodeCallAlertVisible: false,
        hubspotAuthenticatorResponse: null,
        isPasskeyUnsupportedAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SWITCH_TWO_FACTOR_METHOD:
      return Object.assign({}, state, {
        twoFactorLevel: state.twoFactorLevel === TwoFactorAuthLevels.PRIMARY ? TwoFactorAuthLevels.SECONDARY : TwoFactorAuthLevels.PRIMARY,
        totp: '',
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false,
        isNewCodeSentAlertVisible: false,
        isCodeCallAlertVisible: false,
        hubspotAuthenticatorResponse: null,
        isLoginWithHSPrompt: false,
        isPasskeyUnsupportedAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SET_CREDENTIALS:
      return Object.assign({}, state, {
        credentials: action.payload.credentials
      });
    case TwoFactorAuthActionTypes.SET_TOKEN:
      return Object.assign({}, state, {
        token: action.payload.token
      });
    case TwoFactorAuthActionTypes.SHOW_TOKEN_EXPIRED:
      return Object.assign({}, state, {
        isTokenExpiredAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_TOKEN_EXPIRED:
      return Object.assign({}, state, {
        isTokenExpiredAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_NEW_CODE_SENT:
      return Object.assign({}, state, {
        isNewCodeSentAlertVisible: true,
        isCodeCallAlertVisible: false,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_CODE_CALL_ALERT:
      return Object.assign({}, state, {
        isCodeCallAlertVisible: true,
        isNewCodeSentAlertVisible: false,
        isInvalidCodeAlertVisible: false,
        isGenericTwoFactorErrorAlertVisible: false
      });
    case TwoFactorAuthActionTypes.HIDE_NEW_CODE_SENT:
      return Object.assign({}, state, {
        isNewCodeSentAlertVisible: false
      });
    case TwoFactorAuthActionTypes.HIDE_CODE_CALL_ALERT:
      return Object.assign({}, state, {
        isCodeCallAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_INVALID_CODE:
      return Object.assign({}, state, {
        isInvalidCodeAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_INVALID_CODE:
      return Object.assign({}, state, {
        isInvalidCodeAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_INVALID_TOKEN:
      return Object.assign({}, state, {
        isInvalidTokenAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_INVALID_TOKEN:
      return Object.assign({}, state, {
        isInvalidTokenAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_SMS_RATE_LIMIT:
      return Object.assign({}, state, {
        isSmsRateLimitAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_SMS_RATE_LIMIT:
      return Object.assign({}, state, {
        isSmsRateLimitAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_GENERIC_TWO_FACTOR_ERROR:
      return Object.assign({}, state, {
        isGenericTwoFactorErrorAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_GENERIC_TWO_FACTOR_ERROR:
      return Object.assign({}, state, {
        isGenericTwoFactorErrorAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_USER_DEACTIVATED:
      return Object.assign({}, state, {
        isUserDeactivatedAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_USER_DEACTIVATED:
      return Object.assign({}, state, {
        isUserDeactivatedAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_RESTRICTED_IP_ADDRESS:
      return Object.assign({}, state, {
        isRestrictedIpAddressAlertVisible: true
      });
    case TwoFactorAuthActionTypes.SHOW_BLOCKED_LOGIN_METHOD_ERROR:
      return Object.assign({}, state, {
        isBlockedLoginMethodAlertVisible: true
      });
    case TwoFactorAuthActionTypes.HIDE_BLOCKED_LOGIN_METHOD_ERROR:
      return Object.assign({}, state, {
        isBlockedLoginMethodAlertVisible: false
      });
    case TwoFactorAuthActionTypes.SHOW_PASSKEY_UNSUPPORTED_ERROR:
      return Object.assign({}, state, {
        isPasskeyUnsupportedAlertVisible: true
      });
    case TwoFactorAuthActionTypes.SET_VETTING_URL:
      return Object.assign({}, state, {
        vettingUrl: action.payload.vettingUrl
      });
    case TwoFactorAuthActionTypes.TOGGLE_REMEMBER_DEVICE:
      return Object.assign({}, state, {
        rememberThisDevice: !state.rememberThisDevice
      });
    case TwoFactorAuthActionTypes.SWITCH_APP_STATE:
      {
        const appState = state.appState === TwoFactorAuthAppStates.DEFAULT ? TwoFactorAuthAppStates.BACKUP : TwoFactorAuthAppStates.DEFAULT;
        const twoFactorLevel = action.payload.level || state.twoFactorLevel;
        return Object.assign({}, state, {
          appState,
          twoFactorLevel,
          totp: '',
          isInvalidCodeAlertVisible: false,
          isGenericTwoFactorErrorAlertVisible: false,
          isNewCodeSentAlertVisible: false,
          isCodeCallAlertVisible: false,
          hubspotAuthenticatorResponse: undefined
        });
      }
    case TwoFactorAuthActionTypes.UPDATE_HUBSPOT_APP_STATUS:
      return Object.assign({}, state, {
        hubspotAuthenticatorResponse: action.payload
      });
    case TwoFactorAuthActionTypes.CLICKED_BACK_BUTTON:
      return initialState;
    case TwoFactorAuthActionTypes.LOGIN_WITH_HS_PROMPT:
      return Object.assign({}, state, {
        isLoginWithHSPrompt: true
      });
    case TwoFactorAuthActionTypes.SET_USE_PASSKEY_FOR_2FA:
      return Object.assign({}, state, {
        usePasskey: action.payload.usePasskey
      });
    case TwoFactorAuthActionTypes.SET_PASSKEY_AAGUIDS:
      return Object.assign({}, state, {
        passkeyAaguids: action.payload.passkeyAaguids
      });
    default:
      return state;
  }
}